module.exports = __webpack_public_path__ + "49173713c7e6dbd0dc5fa37a5db41197.pdf";